import { ImageData, CHANGE_NAME, SELECT_IMAGE, EDITING_IMAGE_NAME, DELETE_IMAGE, CLOSE_EDITING_IMAGE, ADD_IMAGES, ImageCRUD, AddImageAction, DES_SELECT_IMAGE, RESET_IMAGES } from '../../Actions/Atlas/images.action';
import preventImageNameDuplicate from '../../../utils/preventImageNameDuplicate';
import { RESET_ALL } from '../../Actions/globals.actions';

// import images_default from '../anim_images_test.json';

// const defaultImagesData: ImageData[] = images_default;
const defaultImagesData: ImageData[] = [];

export default (state: ImageData[] = defaultImagesData, action: ImageCRUD & AddImageAction) => {
    switch (action.type) {
        case ADD_IMAGES: {
            action.payload.forEach(image =>{
                image.name = preventImageNameDuplicate(image, state);
            });
            return [...state, ...action.payload]
        }
        case CHANGE_NAME: {
            const newState = state.map(image => (image.id === action.payload.id) ? (image.name = action.payload.name, image) : image);
            return newState;
        }
        case SELECT_IMAGE: {
            const newState = state.map(image =>
                (image.id === action.payload.id)
                    ? (image.active = true, image)
                    : (image.active = false, image));
            return newState;
        }
        case DES_SELECT_IMAGE: {
            const newState = state.map(image => { return (image.active = false, image); });
            return newState;
        }
        case EDITING_IMAGE_NAME: {
            const newState = state.map(image =>
                (image.id === action.payload.id)
                    ? (image.changeName = true, image)
                    : (image.changeName = false, image));
            return newState;
        }
        case CLOSE_EDITING_IMAGE: {
            const newState = state.map(image => {
                if(image.changeName){
                   image.name = preventImageNameDuplicate(image, state);
                }
                image.changeName = false;
                return image
            });
            return newState;
        }
        case DELETE_IMAGE: {
            return state.filter(image => (image.id !== action.payload.id));
        }
        case RESET_IMAGES: {
            return defaultImagesData;
        }
        case RESET_ALL: {
            return defaultImagesData;
        }
        default:
            return state;
    }
}
